import { render, staticRenderFns } from "./HotelDetailImages.vue?vue&type=template&id=ffffb932&scoped=true&"
import script from "./HotelDetailImages.vue?vue&type=script&lang=js&"
export * from "./HotelDetailImages.vue?vue&type=script&lang=js&"
import style0 from "./HotelDetailImages.vue?vue&type=style&index=0&id=ffffb932&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffffb932",
  null
  
)

export default component.exports